import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Lemonada', cursive;
    font-size: 16px;
    color: #555555;
  }
`;

export default GlobalStyle;